var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1149_5678)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.9 17.2996C20.6 17.2996 22.7 15.0996 22.7 12.3996C22.7 9.69961 20.5 7.59961 17.8 7.59961C15.1 7.59961 13 9.79961 13 12.3996C13 15.0996 15.2 17.2996 17.9 17.2996ZM17.8 9.59961C17.9 9.59961 17.9 9.59961 17.8 9.59961C19.4 9.59961 20.7 10.8996 20.7 12.4996C20.7 14.0996 19.4 15.2996 17.8 15.2996C16.2 15.2996 15 13.9996 15 12.4996C15 10.8996 16.3 9.59961 17.8 9.59961Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.7 16.7009C30.8 15.0009 28.3 14.1009 25.7 14.2009H24.9C24.7 15.0009 24.4 15.7009 24 16.3009C24.6 16.2009 25.1 16.2009 25.7 16.2009C27.6 16.1009 29.5 16.7009 31 17.8009V25.0009H33V17.0009L32.7 16.7009Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4 7.80078C23.9 6.60078 25.3 6.00078 26.6 6.50078C27.8 7.00078 28.4 8.40078 27.9 9.70078C27.5 10.6008 26.6 11.2008 25.7 11.2008C25.5 11.2008 25.2 11.2008 25 11.1008C25.1 11.6008 25.1 12.1008 25.1 12.5008V13.1008C25.3 13.1008 25.5 13.2008 25.7 13.2008C28.2 13.2008 30.2 11.2008 30.2 8.80078C30.2 6.30078 28.2 4.30078 25.8 4.30078C24.2 4.30078 22.8 5.10078 22 6.50078C22.5 6.80078 23 7.20078 23.4 7.80078Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 16.4005C11.6 15.8005 11.3 15.1005 11.1 14.3005H10.3C7.7 14.2005 5.2 15.1005 3.3 16.7005L3 17.0005V25.0005H5V17.8005C6.6 16.7005 8.4 16.1005 10.3 16.2005C10.9 16.2005 11.5 16.3005 12 16.4005Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2998 13.1002C10.4998 13.1002 10.6998 13.1002 10.8998 13.0002V12.4002C10.8998 11.9002 10.8998 11.4002 10.9998 11.0002C10.7998 11.1002 10.4998 11.1002 10.2998 11.1002C8.99977 11.1002 7.89977 10.0002 7.89977 8.70016C7.89977 7.40016 8.99977 6.30016 10.2998 6.30016C11.2998 6.30016 12.1998 6.90016 12.5998 7.80016C12.9998 7.30016 13.5998 6.80016 14.0998 6.40016C12.7998 4.30016 10.0998 3.60016 7.99977 4.90016C5.89977 6.20016 5.19977 8.90016 6.49977 11.0002C7.29977 12.3002 8.69977 13.1002 10.2998 13.1002Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1 22.6995L25.9 22.3995C23.9 20.1995 21.1 18.8995 18.1 18.9995C15.1 18.8995 12.2 20.1995 10.2 22.3995L10 22.6995V30.2995C10 31.1995 10.7 31.9995 11.7 31.9995H24.5C25.4 31.9995 26.2 31.1995 26.2 30.2995V22.6995H26.1ZM24.1 29.9995H12V23.3995C13.6 21.7995 15.8 20.9995 18.1 20.9995C20.3 20.8995 22.5 21.7995 24.1 23.3995V29.9995Z",
    fill: "current"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1149_5678"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup);
export default __webpack_public_path__ + "static/media/group.61de162c2fe71b54df81ddc0d126383a.svg";
export { ForwardRef as ReactComponent };